module.exports = __webpack_public_path__ + "static/bg-sec5-3-d88e6fed8384ed3bd35f52365fe1b4dd.jpg";